import { Injectable } from '@angular/core';

@Injectable()
export class DecisionsTransformService {

  constructor() { }



  public transform(type,petitionStatusId) {
    var title = 'შეტყობინება';
        if (type === 2) {
            title = 'ხმის მიცემის დაწყება';
        } else if (type === 3) {
            title = 'ხმის მიცემის შეწყვეტა';
        } else if (type === 4) {
            title = 'დახარვეზება';
        } else {
            if (petitionStatusId === 15) {
                title = 'თანხმობა';
            } else if (petitionStatusId === 17) {
                title = 'უარყოფა';
            } else if (petitionStatusId === 10) {
                title = 'უარყოფა';
            } else if (petitionStatusId === 4 || petitionStatusId === 5) {
                title = 'დაბლოკვა';
            }
        }
        return title;
  };
}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/services/admin/decisions-transform.service.ts